'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { ELanguage } from '../../Utils/constants.js';
import { FOLLOW_COMPANY_API_END_POINT } from './const.js';

var followCompany = function (baseMsUrl, companyId, isFollow, accessToken, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var postData, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                postData = {
                    companyId: companyId,
                    status: isFollow
                };
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(FOLLOW_COMPANY_API_END_POINT), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode || ELanguage.VI,
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { followCompany };
//# sourceMappingURL=index.js.map
